import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): boolean {
    if (this.authService.isAuthenticated()) {
      return true;
    }
    
    this.router.navigate(['/login']);
    return false;
  }
}

@Injectable({
  providedIn: 'root'
})
export class StaffGuard {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): boolean {
    if (this.authService.isAuthenticated() && this.authService.isStaff()) {
      return true;
    }
    
    if (this.authService.isAuthenticated()) {
      // User is authenticated but not staff, redirect to user dashboard
      this.router.navigate(['/user/dashboard']);
    } else {
      // User is not authenticated, redirect to login
      this.router.navigate(['/login']);
    }
    return false;
  }
}

@Injectable({
  providedIn: 'root'
})
export class UserGuard {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): boolean {
    if (this.authService.isAuthenticated() && this.authService.isUser()) {
      return true;
    }
    
    if (this.authService.isAuthenticated()) {
      // User is authenticated but not a regular user, redirect to staff dashboard
      this.router.navigate(['/staff/dashboard']);
    } else {
      // User is not authenticated, redirect to login
      this.router.navigate(['/login']);
    }
    return false;
  }
}

@Injectable({
  providedIn: 'root'
})
export class LoginGuard {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): boolean {
    if (this.authService.isAuthenticated()) {
      const user = this.authService.getCurrentUser();
      if (user?.userType === 'staff') {
        this.router.navigate(['/staff/dashboard']);
      } else {
        this.router.navigate(['/user/dashboard']);
      }
      return false;
    }
    
    return true;
  }
} 